import React from "react";
import cmsGrayTextLogin from "../../assets/images/logo-white.png";
import ProgressSteps from "./ProgressSteps";

const SidebarLogo = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="m-8 flex h-auto w-full max-w-[160px] items-center justify-center">
        <img
          src={cmsGrayTextLogin}
          alt="ProTeams Logo"
          className="h-auto w-full object-contain"
        />
      </div>
    </div>
  );
};

const AuthLayout = ({ children, sideContent, title, subtitle, register, currentStep }) => {
  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Left side - Form */}
      <div className="flex w-full flex-col items-center justify-center p-4 sm:p-8 lg:w-[45%]">
        <div className="w-full max-w-md">
          {/* Logo with shaded background */}
          <div className="mx-3 mb-88 flex items-center justify-center rounded-lg bg-[#2c3440] p-4 md:justify-start sm:mx-0">
            <SidebarLogo />
          </div>

          {/* Header */}
          <div className="mb-10 px-4 sm:px-0">
            {register && (
              <div className="mb-8 space-y-2">
                <ProgressSteps currentStep={currentStep} totalSteps={2} />
              </div>
            )}
            <h2 className="text-3xl font-bold mv-8">{title}</h2>
            <p className="text-gray-600">{subtitle}</p>
          </div>

          {children}
        </div>
      </div>

      {/* Right side - Image/Info */}
      {sideContent && (
        <div className="hidden bg-[#2c3440] px-10 py-8 text-white lg:block lg:w-[55%] xl:px-14 xl:py-10">
          {sideContent}
        </div>
      )}
    </div>
  );
};

export default AuthLayout;
